import styled from 'styled-components'
import { getDateDropdownStyles } from '../style'
import { DateDropdownProps } from '../type'

const StyledDateDropdown = styled.div.withConfig({
    shouldForwardProp: (prop) => !['isOpen', 'error'].includes(prop)
})<DateDropdownProps>`
    ${getDateDropdownStyles}
`

export default StyledDateDropdown
